<template>

    <cms-form-modal title="Gebruiker(s) toewijzen aan project" class="user-assign-project-form-modal" submit-button="Toewijzen"
                    @close="cancel" @submit="submit"
                    :submitting="submitting">

        <search-dropdown title="Project" name="projectId" data-vv-name="projectId" data-vv-as="Project"
                           :options="projectOptions" v-model="projectId" :searchable="true" max-height="100"
                           v-validate="'required'" :error="error('projectId')" @query-changed="onSearchQueryChanged">
        </search-dropdown>

    </cms-form-modal>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import validationMixin from '@wittignl/js-core/mixins/validation'

    import createQuery from '@wittignl/js-core/apollo/queries/createQuery'

    import AllProjectsQuery from 'gql/queries/UserAssignProjectFormModal/AllProjects.gql'

    import UserMutations from "app/mutations/UserMutations"

    import debounce from 'lodash/debounce'

    import SearchDropdown from "app/components/ui/SearchDropdown.vue";

    @Component({

        name: 'user-assign-project-form-modal',
        mixins: [validationMixin],
        props: ['userIds'],
        components: { SearchDropdown },
        apollo: {

            projects: createQuery(AllProjectsQuery, {
                fetchPolicy: 'cache-and-network',

                variables() {

                    return {
                        search: this.query,
                        limit: 20
                    }
                }
            })
        }
    })
    export default class extends Vue {

        data() {

            return {

                loading: 0,

                submitted: false,
                submitting: false,

                query: null,

                projects: null,

                projectId: null
            };
        }

        created() {

            this.logger = this.$di.logger.child('UserAssignProjectFormModal');
        }

        mounted() {

        }

        onSearchQueryChanged(query) {

            if(this.updateDebounced != null) {
                this.updateDebounced.cancel();
            }

            const updateQuery = () => {
                this.query = query;
            }

            this.updateDebounced = debounce(updateQuery, 500);
            this.updateDebounced();
        }

        async submit() {

            this.submitted = true;

            const success = await this.$validator.validateAll();
            if (!success) {

                this.$toast.warning('Een of meerdere velden zijn niet correct ingevuld');
                return;
            }

            try {

                this.submitting = true;

                await UserMutations.connectUsersToProject(this.projectId, this.userIds);

                this.logger.info('User is assigned to the project');

                this.submitting = false;

                this.$emit('dismiss', true);
            }
            catch(e) {

                this.logger.error('Something went wrong', e);
                this.$toast.error('Er is een fout opgetreden tijdens het koppelen');

                this.submitting = false;
            }
        }

        cancel() {

            this.$emit('dismiss', false);
        }

        get projectOptions() {

            if(!this.projects) return [];

            return this.projects.items.map(project => ({ label: project.title, value: project.id }));
        }
    }

</script>
